import { Select, SelectProps } from 'antd';
import classnames from 'classnames';
import React, { useState } from 'react';

import Icon from '@ant-design/icons';
import TableSubHeader from '@components/common/DimensionTable/components/TableSubHeader';
import { ITableSubHeader } from '@components/common/DimensionTable/components/TableSubHeader/typed';
import { eventDimensionNames } from '@components/dimensions/typed';
import LockSvg from '@icons/dimensions/lock.svg';

import styles from './index.less';
import { useIsNewWorkflowPage } from '@src/hooks/useNewWorkflow';

export enum ETitleColor {
  DEFAULT,
  BLUE,
  GREEN,
}

interface ITitle {
  options?: SelectProps['options'];
  value?: string;
  lock?: boolean;
  isUserDefinedDimension?: boolean;
  showTitleFilter?: boolean;
  loading?: boolean;
  onChange?: (value: string) => void;
  color?: ETitleColor;
}

function findOptionItemByValue(options: SelectProps['options'] = [], value: SelectProps['value']) {
  for (const itemOption of options) {
    if ('value' in itemOption && itemOption.value === value) {
      return itemOption;
    } else if ('options' in itemOption) {
      const nestedResult = findOptionItemByValue(itemOption.options, value);
      if (nestedResult) {
        return nestedResult;
      }
    }
  }
  return {};
}

const Title = ({
  value,
  options = [],
  lock = false,
  isUserDefinedDimension = false,
  showTitleFilter = true,
  loading = false,
  onChange,
  color = ETitleColor.DEFAULT,
  onClick,
}: ITitle & Pick<ITableSubHeader, 'onClick'>) => {
  const isFlowPage = useIsNewWorkflowPage();
  const [dimensionKey, setDimensionKey] = useState<string>(value ?? '');

  let colorClassName = '';
  if (color === ETitleColor.GREEN) {
    colorClassName = styles.greenSelect;
  }
  if (color === ETitleColor.BLUE) {
    colorClassName = styles.blueSelect;
  }

  const handleSelectChange = (value) => {
    onChange?.(value);
    setDimensionKey(value);
  };

  const isEventDimension = eventDimensionNames.includes(dimensionKey);

  if (isFlowPage || (lock && !isEventDimension)) {
    const name = findOptionItemByValue(options, dimensionKey).label ?? '';
    return (
      <div className={classnames(styles.dimensionTitle, colorClassName)}>
        <span>{name}</span>
        <Icon style={{ fontSize: 14 }} component={LockSvg} />
        {isUserDefinedDimension && <div className={styles.customTag}>Custom</div>}
      </div>
    );
  }

  return (
    <div className={classnames(styles.dimensionSelect, colorClassName)}>
      <Select
        showSearch
        value={dimensionKey}
        options={options}
        onChange={handleSelectChange}
        bordered={false}
        loading={loading}
        dropdownMatchSelectWidth={250}
        filterOption={(input, option) =>
          ((option?.label as string) ?? '').toLowerCase().includes(input.toLowerCase())
        }
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        dropdownRender={(menu) => {
          return (
            <>
              {showTitleFilter && (
                <TableSubHeader type="Dimension_List" showSearch={false} onClick={onClick} />
              )}
              {menu}
            </>
          );
        }}
      />
      {lock && isEventDimension && <Icon component={LockSvg} />}
      {isUserDefinedDimension && <div className={styles.customTag}>custom dimension</div>}
    </div>
  );
};

export default Title;
